import React from 'react';
import Tag from '../components/ui/Tag';
import type { TagTone } from '../components/ui/Tag';
import { CATEGORY } from '../components/ui/categoryColors';
import { STATUS_BADGES } from '../Customers/types';

interface Look { tone?: TagTone | 'accent'; hex?: string }

const STATUS_LOOK: Record<string, Look> = {
  pending: { tone: 'neutral' },
  confirmed: { tone: 'info' },
  in_production: { hex: CATEGORY.orange.ink.hex },
  ready: { tone: 'good' },
  shipping: { tone: 'warn' },
  shipped: { hex: CATEGORY.purple.ink.hex },
  delivered: { tone: 'good' },
  awaiting_return: { hex: CATEGORY.orange.ink.hex },
  returned: { tone: 'neutral' },
  complete: { hex: CATEGORY.emerald.ink.hex },
  cancelled: { tone: 'bad' },
};

/** An order status as the orders page shows it everywhere. */
const StatusPill: React.FC<{ status: string; size?: 'md' | 'sm' }> = ({ status, size = 'sm' }) => (
  <Tag size={size} className="capitalize" {...(STATUS_LOOK[status] || { tone: 'neutral' })}>
    {status?.replace(/_/g, ' ')}
  </Tag>
);

const TYPE_LOOK: Record<string, Look> = {
  sale: { tone: 'accent' },
  lease: { tone: 'info' },
  rental: { hex: CATEGORY.orange.ink.hex },
};

const RELATION_LOOK: Record<string, Look> = {
  lessee: { tone: 'info' },
  renter: { hex: CATEGORY.orange.ink.hex },
  purchaser: { tone: 'good' },
};

/** An order's type: sale, lease or rental. */
export const OrderTypeTag: React.FC<{ type: string; size?: 'md' | 'sm' }> = ({ type, size = 'sm' }) => (
  <Tag size={size} className="capitalize" {...(TYPE_LOOK[type] || { tone: 'neutral' })}>{type}</Tag>
);

/** How a customer relates to Firefly: lease, rental or purchase. */
export const RelationTag: React.FC<{ badge: string; size?: 'md' | 'sm' }> = ({ badge, size = 'md' }) => (
  <Tag size={size} {...(RELATION_LOOK[badge] || { tone: 'neutral' })}>{STATUS_BADGES[badge].label}</Tag>
);

export default StatusPill;
